import { NormalizedUnitNumber } from '@/domain/types/NumericValues'
import { Token } from '@/domain/types/Token'
import { TokenIcon } from '@/ui/atoms/token-icon/TokenIcon'
import { Typography } from '@/ui/atoms/typography/Typography'
import { L1Badge } from '@/ui/molecules/l1-badge/L1Badge'

interface TokenListItemProps {
  token: Token
  value: NormalizedUnitNumber
  isL1?: boolean
}

export function TokenListItem({ token, value, isL1 }: TokenListItemProps) {
  return (
    <div className="flex items-center justify-between py-3">
      <div className="flex items-center gap-3">
        <div className="relative">
          <TokenIcon token={token} className="w-10" />
          {isL1 && <L1Badge variant="primary" />}
        </div>
        <div>
          <Typography variant="p">{token.name}</Typography>
          <Typography variant="p" className="text-muted-foreground text-sm">
            {token.format(value, { style: 'compact' })} {token.symbol}
          </Typography>
        </div>
      </div>

      <div className="flex items-center gap-3">
        {token.unitPriceUsd.eq(0) ? (
          <Typography variant="prompt">-</Typography>
        ) : (
          <Typography variant="p">{token.formatUSD(value)}</Typography>
        )}
      </div>
    </div>
  )
}
